/**
 * VisitorContext - 访客国家/货币统一状态（geo 检测、ISO 主键、运费下拉同步）
 */
(function (global) {
  const STORAGE = {
    countryCode: 'countryCode',
    selectedCountry: 'selectedCountry',
    countryManual: 'countryManual',
    currency: 'bucksCurrency',
    currencyManual: 'bucksCurrencyManual'
  };
  const GEO_CACHE_KEY = 'shopifyBrowsingContextCache';

  const EUR_COUNTRIES = new Set([
    'AD', 'AT', 'BE', 'CY', 'DE', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'IE', 'IT',
    'LT', 'LU', 'LV', 'MC', 'ME', 'MT', 'NL', 'PT', 'SI', 'SK', 'SM', 'VA', 'XK',
    'GF', 'GP', 'MQ', 'YT', 'RE', 'PM', 'BL', 'MF', 'TF'
  ]);

  const COUNTRY_CURRENCY = {
    US: 'USD', CA: 'CAD', MX: 'MXN', GB: 'GBP', CH: 'CHF', NO: 'NOK', SE: 'SEK',
    DK: 'DKK', PL: 'PLN', CZ: 'CZK', HU: 'HUF', RO: 'RON', BG: 'BGN', IS: 'ISK',
    JP: 'JPY', CN: 'CNY', KR: 'KRW', HK: 'HKD', TW: 'TWD', SG: 'SGD', MY: 'MYR',
    TH: 'THB', ID: 'IDR', PH: 'PHP', VN: 'VND', IN: 'INR', PK: 'PKR', BD: 'BDT',
    LK: 'LKR', NP: 'NPR', MM: 'MMK', KH: 'KHR', LA: 'LAK', MN: 'MNT', KZ: 'KZT',
    UZ: 'UZS', KG: 'KGS', TJ: 'TJS', TM: 'TMT', AF: 'AFN', BT: 'BTN', MV: 'MVR',
    AE: 'AED', SA: 'SAR', QA: 'QAR', KW: 'KWD', BH: 'BHD', OM: 'OMR', JO: 'JOD',
    IL: 'ILS', TR: 'TRY', IQ: 'IQD', IR: 'IRR', LB: 'LBP', PS: 'ILS', YE: 'YER',
    SY: 'SYP', GE: 'GEL', AM: 'AMD', AZ: 'AZN',
    ZA: 'ZAR', NG: 'NGN', EG: 'EGP', KE: 'KES', GH: 'GHS', MA: 'MAD', TZ: 'TZS',
    UG: 'UGX', ET: 'ETB', DZ: 'DZD', TN: 'TND', LY: 'LYD', SD: 'SDG', AO: 'AOA',
    MZ: 'MZN', ZM: 'ZMW', ZW: 'ZWL', BW: 'BWP', NA: 'NAD', MU: 'MUR', RW: 'RWF',
    SN: 'XOF', CI: 'XOF', CM: 'XAF', CD: 'CDF', MG: 'MGA', MW: 'MWK', LS: 'LSL',
    SZ: 'SZL', GM: 'GMD', GN: 'GNF', SL: 'SLL', LR: 'LRD', MR: 'MRU', BJ: 'XOF',
    BF: 'XOF', ML: 'XOF', NE: 'XOF', TG: 'XOF', GA: 'XAF', CG: 'XAF', CF: 'XAF',
    TD: 'XAF', GQ: 'XAF', KM: 'KMF', DJ: 'DJF', ER: 'ERN', SO: 'SOS', SS: 'SSP',
    AU: 'AUD', NZ: 'NZD', FJ: 'FJD', PG: 'PGK', WS: 'WST', TO: 'TOP', VU: 'VUV',
    SB: 'SBD', NC: 'XPF', PF: 'XPF', WF: 'XPF',
    BR: 'BRL', AR: 'ARS', CL: 'CLP', CO: 'COP', PE: 'PEN', VE: 'VES', UY: 'UYU',
    PY: 'PYG', BO: 'BOB', EC: 'USD', PA: 'PAB', CR: 'CRC', GT: 'GTQ', HN: 'HNL',
    NI: 'NIO', SV: 'USD', DO: 'DOP', CU: 'CUP', HT: 'HTG', JM: 'JMD', TT: 'TTD',
    BB: 'BBD', BS: 'BSD', BZ: 'BZD', KY: 'KYD', AW: 'ANG', CW: 'ANG', SX: 'ANG',
    BM: 'BMD', AG: 'XCD', DM: 'XCD', GD: 'XCD', KN: 'XCD', LC: 'XCD', VC: 'XCD',
    SR: 'SRD', GY: 'GYD', FK: 'FKP', GI: 'GIP', GG: 'GBP', JE: 'GBP', IM: 'GBP',
    SH: 'SHP', RU: 'RUB', UA: 'UAH', BY: 'BYN', MD: 'MDL', RS: 'RSD', BA: 'BAM',
    MK: 'MKD', AL: 'ALL', FO: 'DKK', GL: 'DKK', LI: 'CHF',
    MO: 'MOP', BN: 'BND', TL: 'USD', KI: 'AUD', TV: 'AUD', NR: 'AUD',
    CK: 'NZD', NU: 'NZD', PN: 'NZD', TK: 'NZD', AI: 'XCD', VG: 'USD', TC: 'USD',
    MS: 'XCD', CV: 'CVE', ST: 'STN', SC: 'SCR'
  };

  let countryDataPromise = null;
  let codeToName = null;
  let nameToCode = null;
  let geoPromise = null;

  function config() {
    return global.__visitorContextConfig || {};
  }

  function getBrowsingContextUrl() {
    const root = (global.Shopify && global.Shopify.routes && global.Shopify.routes.root) || '/';
    return root + 'browsing_context_suggestions.json';
  }

  function loadCountryData() {
    if (countryDataPromise) return countryDataPromise;
    const url = config().countryDataUrl;
    if (!url) {
      countryDataPromise = Promise.resolve([]);
      return countryDataPromise;
    }
    countryDataPromise = fetch(url)
      .then(function (r) { return r.ok ? r.json() : []; })
      .then(function (data) {
        codeToName = {};
        nameToCode = {};
        (data || []).forEach(function (row) {
          if (!row || !row.code) return;
          const code = String(row.code).toUpperCase();
          if (row.country) {
            codeToName[code] = row.country;
            nameToCode[row.country] = code;
          }
        });
        return data;
      })
      .catch(function () { return []; });
    return countryDataPromise;
  }

  function fetchBrowsingContext() {
    if (geoPromise) return geoPromise;
    geoPromise = (function () {
      try {
        const cached = sessionStorage.getItem(GEO_CACHE_KEY);
        if (cached) return Promise.resolve(JSON.parse(cached));
      } catch (e) {}
      return fetch(getBrowsingContextUrl(), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (data) {
            try { sessionStorage.setItem(GEO_CACHE_KEY, JSON.stringify(data)); } catch (e) {}
          }
          return data;
        })
        .catch(function () { return null; });
    })();
    return geoPromise;
  }

  function getCountryCode() {
    try { return localStorage.getItem(STORAGE.countryCode) || ''; } catch (e) { return ''; }
  }

  function getSelectedCountry() {
    try { return localStorage.getItem(STORAGE.selectedCountry) || ''; } catch (e) { return ''; }
  }

  function getCurrency() {
    try { return localStorage.getItem(STORAGE.currency) || ''; } catch (e) { return ''; }
  }

  function isCurrencyManual() {
    try { return localStorage.getItem(STORAGE.currencyManual) === '1'; } catch (e) { return false; }
  }

  function getCurrencyForCountryCode(countryCode) {
    if (!countryCode) return null;
    const code = String(countryCode).toUpperCase();
    if (EUR_COUNTRIES.has(code)) return 'EUR';
    return COUNTRY_CURRENCY[code] || null;
  }

  function setCountry(isoCode, englishName, options) {
    if (!isoCode) return;
    const code = String(isoCode).toUpperCase();
    const opts = options || {};
    try {
      localStorage.setItem(STORAGE.countryCode, code);
      if (englishName) localStorage.setItem(STORAGE.selectedCountry, englishName);
      if (opts.manual) {
        localStorage.setItem(STORAGE.countryManual, '1');
      } else if (!opts.preserveManual) {
        localStorage.removeItem(STORAGE.countryManual);
      }
    } catch (e) {}
    if (opts.syncSelect !== false) {
      syncCountrySelects(code, englishName);
    }
  }

  function setCountryByOptionValue(optionValue) {
    if (!optionValue || optionValue === '---') return;
    try {
      localStorage.setItem(STORAGE.selectedCountry, optionValue);
      localStorage.setItem(STORAGE.countryManual, '1');
      if (nameToCode && nameToCode[optionValue]) {
        localStorage.setItem(STORAGE.countryCode, nameToCode[optionValue]);
      }
    } catch (e) {}
    if (!nameToCode || !nameToCode[optionValue]) {
      loadCountryData().then(function () {
        const iso = nameToCode[optionValue];
        if (iso) {
          try { localStorage.setItem(STORAGE.countryCode, iso); } catch (e) {}
        }
      });
    }
  }

  function syncCountrySelects(isoCode, englishName) {
    if (!isoCode) return;
    const code = String(isoCode).toUpperCase();
    const selects = document.querySelectorAll('#shipping-estimator-country');
    if (!selects.length) return;

    loadCountryData().then(function () {
      const targetName = englishName || codeToName[code] || '';
      selects.forEach(function (select) {
        let matchedValue = '';
        for (let i = 0; i < select.options.length; i++) {
          const opt = select.options[i];
          if (targetName && opt.value === targetName) {
            matchedValue = opt.value;
            break;
          }
        }
        if (!matchedValue) {
          for (let j = 0; j < select.options.length; j++) {
            const opt2 = select.options[j];
            if (nameToCode[opt2.value] === code) {
              matchedValue = opt2.value;
              break;
            }
          }
        }
        if (matchedValue && select.value !== matchedValue) {
          select.value = matchedValue;
          try { localStorage.setItem(STORAGE.selectedCountry, matchedValue); } catch (e) {}
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  function setCurrency(currency, options) {
    if (!currency) return;
    const opts = options || {};
    try {
      localStorage.setItem(STORAGE.currency, currency);
      if (opts.fromUrl) {
        localStorage.removeItem(STORAGE.currencyManual);
      } else if (opts.manual) {
        localStorage.setItem(STORAGE.currencyManual, '1');
      }
    } catch (e) {}
  }

  function isCountryManual() {
    try { return localStorage.getItem(STORAGE.countryManual) === '1'; } catch (e) { return false; }
  }

  function ensureCountry() {
    const existingCode = getCountryCode();
    const existingName = getSelectedCountry();
    if (existingCode && existingName) {
      return Promise.resolve({ iso: existingCode, name: existingName });
    }
    if (isCountryManual() && existingName) {
      return loadCountryData().then(function () {
        const iso = nameToCode[existingName] || existingCode;
        if (iso) {
          try { localStorage.setItem(STORAGE.countryCode, iso); } catch (e) {}
        }
        return { iso: iso || existingCode, name: existingName };
      });
    }

    return fetchBrowsingContext().then(function (data) {
      const country = data && data.detected_values && data.detected_values.country;
      if (!country || !country.handle) return null;
      const iso = String(country.handle).toUpperCase();
      return loadCountryData().then(function () {
        const englishName = codeToName[iso] || country.name || '';
        setCountry(iso, englishName);
        return { iso: iso, name: englishName };
      });
    });
  }

  function getGeoForWidget() {
    return fetchBrowsingContext().then(function (data) {
      const country = data && data.detected_values && data.detected_values.country;
      if (!country) return data;
      return Object.assign({}, data, {
        country_code: country.handle,
        country_name: country.name || (data.detected_values && data.detected_values.country_name),
        source: 'shopify'
      });
    });
  }

  function bindCountrySelectChange() {
    document.querySelectorAll('#shipping-estimator-country').forEach(function (select) {
      if (select.dataset.visitorContextBound) return;
      select.dataset.visitorContextBound = '1';
      select.addEventListener('change', function () {
        const val = select.options[select.selectedIndex] && select.options[select.selectedIndex].value;
        if (val) setCountryByOptionValue(val);
      }, true);
    });
  }

  function observeCountrySelects() {
    if (!global.MutationObserver) return;
    const observer = new MutationObserver(function () { bindCountrySelectChange(); });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  loadCountryData();

  function syncStoredCountryToSelects() {
    const code = getCountryCode();
    const name = getSelectedCountry();
    if (code || name) {
      return loadCountryData().then(function () {
        if (code) syncCountrySelects(code, name);
      });
    }
    return Promise.resolve();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindCountrySelectChange();
      observeCountrySelects();
      syncStoredCountryToSelects();
    });
  } else {
    bindCountrySelectChange();
    observeCountrySelects();
    syncStoredCountryToSelects();
  }

  global.VisitorContext = {
    loadCountryData: loadCountryData,
    fetchBrowsingContext: fetchBrowsingContext,
    ensureCountry: ensureCountry,
    getGeoForWidget: getGeoForWidget,
    getCountryCode: getCountryCode,
    getSelectedCountry: getSelectedCountry,
    getCurrency: getCurrency,
    isCurrencyManual: isCurrencyManual,
    getCurrencyForCountryCode: getCurrencyForCountryCode,
    setCountry: setCountry,
    setCountryByOptionValue: setCountryByOptionValue,
    isCountryManual: isCountryManual,
    syncCountrySelects: syncCountrySelects,
    setCurrency: setCurrency,
    getNameToCodeMap: function () { return nameToCode || {}; }
  };
})(window);
